import Backdrop from "components/global/Backdrop";
import Spacer from "components/global/Spacer";
import styled from "styled-components";
import { connect } from "react-redux";
import PlatformPhoto from "components/global/PlatformPhoto";
import { socialIcons, supportedPlatforms } from "constants/post";
import Button from "components/global/Button";
import { useHistory } from "react-router-dom";
import { toggleModalVisibility } from "utils/utils";
import useLimitation from "hooks/useLimitation";

const Wrapper = styled(Backdrop)`
  z-index: 15;

  .card {
    width: fit-content;
    margin: auto;
    max-height: 658px;
    overflow: auto;
    background-color: var(--white);
    border-radius: 16px;
  }

  .card-body {
    padding: 24px;
  }

  .divider {
    width: 100%;
    height: 1px;
    margin-block: 24px;
    background-color: var(--grey_10);
  }

  .brand-group {
    gap: 12px;
  }

  .brand-item {
    padding: 6px;
    border-radius: 8px;
    border: 1px solid var(--grey_10);

    .brand-name {
      margin-bottom: 6px;
    }

    .socials {
      padding: 6px;
      background-color: var(--off_white);
      border-radius: 8px;
    }

    .not-connected {
      border-radius: 50%;
      height: 36px;
      width: 36px;
      background-color: var(--white);
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 100%;
      }
    }
  }

  .action-btns {
    gap: 24px;
    padding: 24px;
    border-top: 1px solid var(--grey_10);
    position: sticky;
    bottom: 0;
    background-color: var(--white);
  }

  .btn {
    width: calc(50% - 12px);
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 48px);
      margin-block: 48px;
      max-height: 80vh;
    }

    .card-body {
      padding: 24px;
    }

    .action-btns {
      padding: 24px;
    }

    .btn {
      min-width: unset;
      width: calc(50% - 24px);
    }
  }
`;

const AddBrandModal = ({ active_account, brands }) => {
  const history = useHistory();
  const { privileges, canAddMoreBrands } = useLimitation(active_account);
  const remainingSlots = privileges?.max_brands;

  const handleClose = () => {
    toggleModalVisibility("#addBrandModal");
  };

  const handleUpgrade = () => {
    handleClose();
    toggleModalVisibility("#upgradePlan.confirmModal");
  };

  return (
    <Wrapper
      id="addBrandModal"
      onClick={(e) => {
        if (e.target.id === e.currentTarget.id) {
          handleClose();
        }
      }}
    >
      <div className="card">
        <div className="card-body">
          <h5>Add a new brand</h5>
          <Spacer y={2.4} />
          <p className="l3 semiBold">Current brands</p>
          <p className="l4 colorBodyText">
            See all your brands and connected social channels.
          </p>
          <Spacer y={1.2} />
          <div className="flexColumn brand-group">
            {brands?.map((brand) => {
              const socials = brand?.socials?.socials;
              const notConnected = supportedPlatforms.filter(
                (platform) =>
                  !socials?.find((channel) => channel.platform === platform)
              );

              return (
                <div key={brand.id} className="brand-item">
                  <p className="l4 brand-name">{brand.name}</p>
                  <div className="flexRow justifySpaceBetween socials">
                    {socials?.map((channel, idx) => {
                      const { platform, page } = channel;

                      return (
                        <PlatformPhoto key={idx}>
                          <img
                            src={socialIcons.circle[platform]}
                            className="platformImg"
                            alt="icon"
                          />
                        </PlatformPhoto>
                      );
                    })}
                    {notConnected.map((platform) => (
                      <div key={platform} className="not-connected ">
                        <img src={socialIcons.grey[platform]} alt="icon" />
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="divider"></div>
          <p className="l3 semiBold">New brand</p>
          <p className="l4 colorBodyText">
            You have {remainingSlots} available brand slots remaining.
          </p>
          <Spacer y={1.2} />
          <div className="brand-item">
            <p className="l4 brand-name">Brand name</p>
            <div className="flexRow justifySpaceBetween socials">
              {supportedPlatforms.map((platform) => (
                <div key={platform} className="not-connected">
                  <img src={socialIcons.grey[platform]} alt="icon" />
                </div>
              ))}
            </div>
          </div>
          <Spacer y={2.4} />
        </div>
        <div className="flexRow justifyCenter fullWidth action-btns">
          <Button
            text="Cancel"
            className="borderedGrey btn"
            height="40px"
            onClick={handleClose}
          />
          <Button
            text={canAddMoreBrands ? "Add a brand" : "Upgrade plan"}
            className="btn"
            height="40px"
            onClick={() => {
              canAddMoreBrands
                ? history.push(`/dashboard/brands/create`)
                : handleUpgrade();
            }}
          />
        </div>
      </div>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    active_account: state.active_account,
    brands: state.brands,
  };
};

export default connect(mapStateToProps)(AddBrandModal);
